import { api } from "./configs/axiosConfigs"

export const SpecificUsesAPI = {
    
    getSpecificUses: async (data:any) => {
        const response = await api.get(
            '/specificuses', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSpecificUsesByCompany: async (data:any) => {
        const response = await api.get(
            '/specificuses/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSpecificUsesByUse: async (data:any) => {
        const response = await api.get(
            '/specificuses/listByUse', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createSpecificUse: async (data: any) => {
        const response = await api.post(
            '/specificuses/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editSpecificUse: async (idattribute: number, data: any) => {
        const response = await api.patch(
            `/specificuses/${idattribute}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteSpecificUse: async (idattribute: number) => {
        const response = await api.delete(
            `/specificuses/${idattribute}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}